import { render } from "./PremiumHandoverHistoryModal.vue?vue&type=template&id=29965685&scoped=true"
import script from "./PremiumHandoverHistoryModal.vue?vue&type=script&lang=js"
export * from "./PremiumHandoverHistoryModal.vue?vue&type=script&lang=js"

import "./PremiumHandoverHistoryModal.vue?vue&type=style&index=0&id=29965685&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29965685"]])

export default __exports__